import { Box, Grid, Typography, Container } from '@mui/material'
import useScrollAnimation from './useScrollAnimation'

const WhyEPOC7 = () => {
  useScrollAnimation('.details .detail') // Keep using your scroll animation hook

  return (
    <Box
      component="section"
      id="why-epoch7"
      sx={{
        py: { xs: 6, md: 10 },
        px: { xs: 2, md: 6 },
        backgroundColor: '#fff',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4} alignItems="center">
          {/* Image Section */}
          <Grid item xs={12} md={6}>
            <Box
              component="img"
              src="/assets/document-templates/why-epoch.png"
              alt="Why EPOCH7"
              sx={{ borderRadius: 2 }}
            />
          </Grid>

          {/* Text Content */}
          <Grid item xs={12} md={6}>
            <Typography className="mb-2" variant="h4" component="h2" gutterBottom>
              Why Epoch7?
            </Typography>

            <Typography
              variant="body1"
              sx={{
                fontWeight: '500',

                mb: 4,
              }}
            >
              Our intuitive and user-friendly interface helps you stay focused and on track, giving
              you the tools you need to make your dreams a reality.
            </Typography>

            <Box className="details">
              {/* Detail Item 1 */}
              <Box className="detail" mb={3}>
                <Typography className="fontsize15" variant="h3" gutterBottom>
                  Customization at your Fingerprint
                </Typography>
                <Typography variant="body2" sx={{ maxWidth: '500' }}>
                  Whether you're in construction, HR, or beyond, Epoch7 adapts to meet your specific
                  needs.
                </Typography>
              </Box>

              {/* Detail Item 2 */}
              <Box className="detail" mb={3}>
                <Typography className="fontsize15" variant="h3" gutterBottom>
                  Scalability and Flexibility
                </Typography>
                <Typography variant="body2">
                  As your business grows, Epoch7 grows with you—offering unlimited flexibility and
                  scalability.
                </Typography>
              </Box>

              {/* Detail Item 3 */}
              <Box className="detail" mb={3}>
                <Typography className="fontsize15" variant="h3" gutterBottom>
                  Seamless Integration
                </Typography>
                <Typography variant="body2">
                  Integrates effortlessly with your existing systems, streamlining workflows and
                  improving productivity.
                </Typography>
              </Box>

              {/* Detail Item 4 */}
              <Box className="detail" mb={3}>
                <Typography className="fontsize15" variant="h3" gutterBottom>
                  Dedicated Support
                </Typography>
                <Typography variant="body2">
                  Our team is always here to help, providing expert support and guidance whenever
                  you need it.
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  )
}

export default WhyEPOC7
